import * as React from 'react';
import {useHVBroadcasts} from 'src/components/messaging/hooks/useHVBroadcasts';
import {classify} from 'src/utils/classify';
import css from './warning-message.css';

import {
  setPunctuationWarningHoverEvent,
  setContentWarningClickInfo,
} from 'src/action-creators/messages';

import {useSelector, useDispatch} from 'react-redux';


type Props = {
  children: React.ReactNode;
  type: string;
  start: number;
  end: number;
};

const WarningMessage = ({children, type, start, end}: Props) => {
  const contentBannerCardType = useSelector(
    // @ts-expect-error - TS2339 - Property 'messages' does not exist on type 'DefaultRootState'.
    (state) => state.messages.contentBannerCardType,
  );
  const contentBannerCardValue = useSelector(
    // @ts-expect-error - TS2339 - Property 'messages' does not exist on type 'DefaultRootState'.
    (state) => state.messages.contentBannerCardValue,
  );
  const {isHVBroadcastLocation} = useHVBroadcasts();

  const dispatch = useDispatch();
  const onMouseEnter = () => {
    dispatch(setPunctuationWarningHoverEvent(type, true));
  };

  const onMouseLeave = () => {
    dispatch(setPunctuationWarningHoverEvent(type, false));
  };

  const onClick = () => {
    if (isHVBroadcastLocation) {
      dispatch(setContentWarningClickInfo(type, start, end));
    }
  };
  return (
    <span
      className={classify(css.text, {
        [css.hover]: contentBannerCardType === type && contentBannerCardValue,
      })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      {children}
    </span>
  );
};

export default WarningMessage;
